/**
 * @file JavaScript loaded in all Widget-type levels.
 */

import $ from 'jquery';
import React from 'react';

import {setupApp} from '@cdo/apps/code-studio/initApp/loadApp';
import initializeCodeMirror6 from '@cdo/apps/code-studio/initializeCodeMirror6';
import {registerGetResult} from '@cdo/apps/code-studio/levels/codeStudioLevels';
import {
  showDialog,
  processResults,
} from '@cdo/apps/code-studio/levels/dialogHelper';
import {
  LegacyStartOverDialog,
  LegacyInstructionsDialog,
} from '@cdo/apps/legacySharedComponents/LegacyDialogContents';
import {reportTeacherReviewingStudentNonLabLevel} from '@cdo/apps/metrics/analyticsUtils';
import i18n from '@cdo/locale';

export function showInstructionsDialog() {
  showDialog(
    <LegacyInstructionsDialog
      title={i18n.puzzleTitle({
        stage_total: appOptions.level.lesson_total,
        puzzle_number: appOptions.level.puzzle_number,
      })}
      markdown={appOptions.level.longInstructions}
    />
  );
}

function setupWidgetLevel() {
  window.script_path = location.pathname;
  setupApp(appOptions);

  appOptions.showInstructionsWrapper(showInstructionsDialog);
  registerGetResult();
  window.options = appOptions.level;
}

// Add globals
window.initializeCodeMirror6 = initializeCodeMirror6;
window.dashboard = window.dashboard || {};
window.dashboard.widget = {
  setupWidgetLevel: setupWidgetLevel,
  // used by pixelation widget
  showStartOverDialog: callback =>
    showDialog(<LegacyStartOverDialog />, callback),
  // used by frequency, vigenere, and pixelation widgets
  processResults: processResults,
};

// On load (note - widget-specific setup may happen before this!)
$(document).ready(function () {
  $('#bubble').click(showInstructionsDialog);

  reportTeacherReviewingStudentNonLabLevel();
});
